export default {
  filter: {
    search: {
      placeholder: 'Filter sellers ...'
    },
    role: {
      all_option: 'All roles'
    },
    status: {
      all_option: 'All statuses'
    },
    country: {
      all_option: 'All countries'
    },
    subscription: {
      placeholder: 'All plans'
    },
    sort: {
      new_to_old: 'New to old',
      old_to_new: 'Old to new'
    },
    logged_status: {
      last_logged_in: 'Last logged in',
      first_logged_in: 'First logged in'
    }
  },
  table_card: {
    set_selected_status_to: 'Set status for {count} selected sellers to : ',
    set_selected_manager_to: 'Set manager for {count} selected sellers to : ',
    not_set: '<span class="red--text">Not set</span>',
    buttons: {
      apply: 'Apply'
    },
    fields: {
      manager: {
        placeholder: 'Select manager'
      }
    },
    no_manager: 'no manager',
    more_info: {
      country: 'Country',
      skype_id: 'Skype id',
      company_name: 'Company name',
      level: 'Level',
      experience_description: 'Experience description',
      referred_from: 'Where did you hear about us ?',
      seller_status: 'Seller status',
      subscribed_to_news_letter: 'Subscribed to news letter ?',
      youtube_profile: 'Youtube profile',
      instagram_profile: 'Instagram profile'
    },
    table: {
      more_info: 'More info',
      sign_up_date: 'Signup date',
      role: 'Role',
      user_name: 'Username',
      full_name: 'Full name',
      contact_details: 'Contact details',
      country: 'Country',
      last_month_confirmed_sales: 'Last 30 days confirmed sales',
      assigned_manager: 'Assigned manager',
      status: 'Status',
      subscription: 'Subscription'
    }
  }
};